<template>
  <div>
    <app-header></app-header>
    <div id="step-1" v-if="step == 1">
      <div class="bg">
        <div class="container content">
          <div class="no-players">
            <div class="text" style="text-align: center">
              Уважаемый пользователь, мы просим Вас заполнить поля.
              <br>
              Эти данные позволят нам расширить перечень тем для самоконтроля.
            </div>
            <div class="col">
              <form @submit.prevent="auth">
<!--                <enter-name @setPage="setStep"></enter-name>-->
                <div class="form-group">
                  <label>ФИО <span style="color: red">*</span></label>
                  <input type="text" id="fio" v-model="fio">
                </div>
                <div class="form-group">
                  <label>Регион <span style="color: red">*</span></label>
                  <v-select v-model="region" :options="regions"></v-select>
                </div>
                <div class="form-group">
                  <label>Email <span style="color: red">*</span></label>
                  <input type="text" id="email" v-model="email">
                  <p v-if="emailError" class="error">Данный Email уже занят</p>
                </div>
                <div style="margin-left: 110px">
                  <div class="form-group">
                    <span class="label">Какие вопросы по деятельности Федеральной антимонопольной службы вызывают у Вас трудности?</span>
                  </div>
                  <div class="form-group">
                    <textarea v-model="startQuest"></textarea>
                  </div>
                </div>
                <div class="form-checkbox">
                  <input id="check" type="checkbox" v-model="checkPersonal" placeholder="Согласен на обработку персональных данных">
                  <label for="check">Согласен на обработку персональных данных</label>
                </div>
                <div class="form-group" style="justify-content: start">
                  <label></label>
                  <button class="btn" type="submit" :disabled="!(fio && email && checkPersonal && region)">Начать</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="step-2" v-if="step == 2">
      <StartGroup @setPage="setStep"/>
    </div>
    <div id="step-3" v-if="step == 3">
      <StartPlayer @setPage="setStep"/>
    </div>

    <div id="step-4" v-if="step == 4">
      <StartTest @setPage="setStep"/>
    </div>

    <app-footer></app-footer>
  </div>
</template>

<script>
  import StartGroup from './StartGroup'
  import StartPlayer from './StartPlayer'
  import StartTest from './StartTest'
  import EnterName from './EnterName'
  import PlayersService from '@/services/PlayersService'

  export default {
    name: 'start',
    components: {
      StartGroup,
      StartPlayer,
      StartTest,
      EnterName
    },
    data () {
      return {
        step: 0,
        regions: [
          'Республика Адыгея',
          'Республика Алтай',
          'Республика Башкортостан',
          'Республика Бурятия',
          'Республика Дагестан',
          'Республика Ингушетия',
          'Кабардино-Балкарская Республика',
          'Республика Калмыкия',
          'Карачаево-Черкесская Республика',
          'Республика Карелия',
          'Республика Коми',
          'Республика Крым',
          'Республика Марий Эл',
          'Республика Мордовия',
          'Республика Саха (Якутия)',
          'Республика Северная Осетия  Алания',
          'Республика Татарстан',
          'Республика Тыва',
          'Удмуртская Республика',
          'Республика Хакасия',
          'Чеченская Республика',
          'Чувашская Республика  Чувашия',
          'Алтайский край',
          'Забайкальский край',
          'Камчатский край',
          'Краснодарский край',
          'Красноярский край',
          'Пермский край',
          'Приморский край',
          'Ставропольский край',
          'Хабаровский край',
          'Амурская область',
          'Архангельская область',
          'Астраханская область',
          'Белгородская область',
          'Брянская область',
          'Владимирская область',
          'Волгоградская область',
          'Вологодская область',
          'Воронежская область',
          'Ивановская область',
          'Иркутская область',
          'Калининградская область',
          'Калужская область',
          'Кемеровская область  Кузбасс',
          'Кировская область',
          'Костромская область',
          'Курганская область',
          'Курская область',
          'Ленинградская область',
          'Липецкая область',
          'Магаданская область',
          'Московская область',
          'Мурманская область',
          'Нижегородская область',
          'Новгородская область',
          'Новосибирская область',
          'Омская область',
          'Оренбургская область',
          'Орловская область',
          'Пензенская область',
          'Псковская область',
          'Ростовская область',
          'Рязанская область',
          'Самарская область',
          'Саратовская область',
          'Сахалинская область',
          'Свердловская область',
          'Смоленская область',
          'Тамбовская область',
          'Тверская область',
          'Томская область',
          'Тульская область',
          'Тюменская область',
          'Ульяновская область',
          'Челябинская область',
          'Ярославская область',
          'Москва',
          'Санкт-Петербург',
          'Севастополь',
          'Еврейская АО',
          'Ненецкий АО',
          'Ханты-Мансийский АО  Югра',
          'Чукотский АО',
          'Ямало-Ненецкий АО'
        ],
        region: '',
        email: '',
        startQuest: '',
        fio: '',
        checkPersonal: true,
        emailError: false
      }
    },
    computed: {
      slug () {
        return this.$route.params.slug
      },
      groupId () {
        return this.$store.getters.groupId
      },
      playerId () {
        return this.$store.getters.getPlayer.id
      },
      testId () {
        return this.$store.getters.testId
      }
    },
    methods: {
      setStep (step) {
        this.step = step
      },
      auth () {
        let vm = this
        let [ln, fn, mn] = vm.fio.toLowerCase().replace(/\s+/g, ' ').trim().split(' ')
        let obj = {
          first_name: fn ? (fn.charAt(0).toUpperCase() + fn.slice(1)) : '',
          middle_name: mn ? (mn.charAt(0).toUpperCase() + mn.slice(1)) : '',
          last_name: ln.charAt(0).toUpperCase() + ln.slice(1),
          email: vm.email,
          payload: {
            region: vm.region,
            start_quest: vm.startQuest
          }
        }
        PlayersService.createPlayer(obj, vm.slug).then(response => {
          vm.emailError = false
          let player = response
          vm.$store.dispatch('setPlayer', player)
          vm.setStep(4)
        }).catch(error => {
          vm.emailError = false
          if (error.email) {
            vm.emailError = true
          }
        })
      }
      // setPlayer (player) {
      //   this.$store.dispatch('setPlayer', player)
      //   if (player.group_set.length === 1) {
      //     this.step = 4
      //   } else if (player.group_set.length > 1) {
      //     this.step = 2
      //   }
      // }
    },
    mounted () {
      let vm = this
      if (this.playerId) {
        this.setStep(4)
      } else {
        PlayersService.getPlayer(2, vm.slug).then(
          (response) => {
            vm.$store.dispatch('setPlayer', response)
            vm.setStep(4)
          },
          (error) => {
            console.log(error)
            vm.setStep(1)
          }
        )
      }
    }
  }
</script>

<style scoped lang="scss">
  .bg {
    position: relative;
  }

  #logo {
    width: 400px;
    position: absolute;
    top: 20px;
    left: 0;
    max-width: 100%;
  }

  #kfu {
    height: 55vh;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .content {
    min-height: calc(100vh - 89px - 122px);
    position: relative;
  }

  .no-players {
    margin-top: 100px;
    @media screen and (max-width: 500px) {
      margin-top: 70px;
    }
    .text {
      color: #000 !important;
      font-weight: 350;
      font-size: 2.0em;
      line-height: 1.5em;
      @media screen and (max-width: 500px) {
        line-height: 1.3em;
      }
    }
  }

  .search-players {
    width: 100%;

    b {
      font-weight: 400;
      font-size: 1.5em;
      display: flex;
    }
  }

  .btn {
    margin-top: 20px;
    box-shadow: none;
    background-color: rgba(88, 162, 221, 0.7);
    border-radius: 10px;
    color: #fff;
    font-weight: 400;
    font-size: 24px;
    &:hover {
      background-color: rgba(88, 162, 221, 1);
      box-shadow: none;
    }
  }
  .label {
    font-weight: 300;
  }
  .form-checkbox {
    text-align: left;
    margin-left: 110px;
    font-weight: 300;
  }
  p.error {
    font-size: 15px;
    color: red;
    text-align: left;
  }
  .col {
    width: 700px;
    max-width: 100%;
    margin: 0 auto;
  }

</style>



// WEBPACK FOOTER //
// src/pages/game/Start.vue